import { useState } from "react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { toast } from "sonner";
import { DownloadSimple, GraduationCap, HardHat, ShieldWarning } from "@phosphor-icons/react";

const REPORTS = [
  { path: "training-matrix.csv", label: "Training Matrix", Icon: GraduationCap, desc: "Every employee vs each competency with current/expiring/expired state.", show: (p) => p("supervisor", "administrator", "auditor", "training_manager") },
  { path: "ppe-register.csv", label: "PPE Register", Icon: HardHat, desc: "All PPE issues with receipt confirmation, status and due dates.", show: (p) => p("supervisor", "administrator", "auditor", "ppe_manager") },
  { path: "rams-acknowledgements.csv", label: "RAMS Acknowledgements", Icon: ShieldWarning, desc: "Who signed which RAMS revision and when.", show: (p) => p("supervisor", "administrator", "auditor", "rams_manager") },
];

export default function ReportsPage() {
  const { hasPerm } = useAuth();
  const [busy, setBusy] = useState("");

  const download = async (r) => {
    setBusy(r.path);
    try {
      const resp = await api.get(`/reports/${r.path}`, { responseType: "blob" });
      const url = URL.createObjectURL(resp.data);
      const a = document.createElement("a");
      a.href = url; a.download = r.path; a.click();
      URL.revokeObjectURL(url);
    } catch (e) { toast.error("Export failed"); } finally { setBusy(""); }
  };

  return (
    <div className="flex flex-col gap-5">
      <h1 className="font-display text-3xl font-black tracking-tight text-slate-900">Reports & Export</h1>
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {REPORTS.filter((r) => r.show(hasPerm)).map((r) => (
          <div key={r.path} className="bg-white border-2 border-slate-300 rounded-lg p-5 flex flex-col gap-3">
            <r.Icon size={28} weight="bold" className="text-slate-700" />
            <div>
              <div className="font-body font-semibold text-slate-900">{r.label}</div>
              <p className="font-body text-sm text-slate-500 mt-1">{r.desc}</p>
            </div>
            <Button data-testid={`report-${r.path}`} onClick={() => download(r)} disabled={busy === r.path}
              className="bg-slate-900 hover:bg-slate-800 font-semibold mt-auto">
              <DownloadSimple size={18} weight="bold" className="mr-1" />{busy === r.path ? "Exporting…" : "Download CSV"}
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
}
